import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, User, Eye, EyeOff } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { username, password });
      localStorage.setItem('admin_token', res.data.token);
      localStorage.setItem('admin_user', res.data.username);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Credenziali non valide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{
      fontFamily: "'Inter', sans-serif",
      background: 'linear-gradient(160deg, #0a1628 0%, #0c2d6b 40%, #1256b9 60%, #0c3577 85%, #0a1628 100%)',
    }}>
      <div className="w-full max-w-[420px]">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-[#0E47B0] rounded-lg flex items-center justify-center mx-auto mb-3">
            <span className="text-white font-bold text-xl">L</span>
          </div>
          <h1 className="text-white text-2xl font-bold">Admin Panel</h1>
          <p className="text-white/50 text-sm mt-1">Lex Recupero™ Lead Management</p>
        </div>

        <div className="bg-[#0b1a3d]/80 backdrop-blur-md rounded-2xl p-8 border border-white/[0.08] shadow-2xl">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-500/15 border border-red-500/30 rounded-lg p-3 text-red-300 text-sm text-center">
                {error}
              </div>
            )}

            <div className="relative">
              <User size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/30" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username"
                required
                className="w-full pl-11 pr-4 py-3.5 bg-[#0e2252]/70 border border-white/[0.12] rounded-lg text-white text-[15px] placeholder-white/40 outline-none focus:border-sky-400/50 transition-all"
              />
            </div>

            <div className="relative">
              <Lock size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/30" />
              <input
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
                className="w-full pl-11 pr-11 py-3.5 bg-[#0e2252]/70 border border-white/[0.12] rounded-lg text-white text-[15px] placeholder-white/40 outline-none focus:border-sky-400/50 transition-all"
              />
              <button
                type="button"
                onClick={() => setShowPw(!showPw)}
                className="absolute right-3.5 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60 bg-transparent border-none cursor-pointer"
              >
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3.5 bg-[#0E47B0] hover:bg-[#1255cc] disabled:opacity-60 text-white font-bold text-base rounded-lg transition-colors cursor-pointer border-none"
            >
              {loading ? 'Accesso...' : 'Accedi'}
            </button>
          </form>

          <p className="text-white/30 text-[11px] text-center mt-5">
            Area riservata agli amministratori
          </p>
        </div>

        <div className="text-center mt-6">
          <a href="/" className="text-white/40 hover:text-white/60 text-sm no-underline transition-colors">
            &larr; Torna al sito
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
